export const optionsButtons = [
  {
    type: 'multi',
    text: ['Manual', 'Auto'],
    name: 'puzzleMode',
  },
  {
    type: 'single',
    text: ['Initial Input Mode'],
    name: 'initialInput',
  },
  {
    type: 'single',
    text: ['Error Warning'],
    name: 'errorWarning',
  },
  {
    type: 'single',
    text: [`Highlight Selected #'s`],
    name: 'highlightSelected',
  },
  {
    type: 'single',
    text: ['Crosshairs'],
    name: 'crosshairs',
  },
  {
    type: 'single',
    text: ['Arrow Scroll Off'],
    name: 'arrowScrollOff',
  },
  {
    type: 'single',
    text: ['Auto-Remove Pencil'],
    name: 'autoRemovePencil',
  },
  {
    type: 'single',
    text: ['Rapid Fill'],
    name: 'rapidFill',
  },
  {
    type: 'multi',
    text: ['Pen', 'Pencil'],
    name: 'penInput',
  },
];

export const gameplayButtons = [
  {
    // text: 'Start Timer',
    name: 'startTimer',
    type: 'single',
    buttonType: 'btn-primary',
    lineBelow: false,
  },
  {
    // text: 'Reset Timer',
    name: 'resetTimer',
    type: 'single',
    buttonType: 'btn-primary',
    lineBelow: true,
  },
  {
    // text: 'Autofill Pencil',
    name: 'autofillPencil',
    type: 'single',
    buttonType: 'btn-primary',
    lineBelow: true,
  },
  {
    // text: 'Ez, Med, Hard',
    name: 'newPuzzle',
    type: 'single',
    buttonType: 'btn-primary',
    lineBelow: false,
  },
  {
    name: 'difficulty',
    type: 'multi',
    buttonType: 'btn-primary',
    lineBelow: true, // false,
  },
  {
    name: 'solve',
    type: 'single',
    buttonType: 'btn-primary',
    lineBelow: true,
  },
  {
    // text: 'Reset Input',
    name: 'resetInput',
    type: 'single',
    buttonType: 'btn-danger',
    lineBelow: false,
  },
];

export const instructionsData = [
  {
    header: 'Navigation and Inserting Numbers',
    instructions: [
      {
        conditions: [{ button: 'rapidFill', value: false }],
        start: '[Not in "Rapid Fill" mode]',
        value:
          ': use either click/touch or arrows to navigate Sudoku board; hold shift while using arrows to move across the board',
      },
      {
        conditions: [{ button: 'rapidFill', value: false }],
        start: '[Not in "Rapid Fill" mode]',
        value:
          ': with a cell selected, either type a number or select a number at the bottom to toggle a value for a particular cell',
      },
      {
        conditions: [{ button: 'rapidFill', value: false }],
        start: '[Not in "Rapid Fill" mode]',
        value: ": delete/backspace keyboard will delete a cell's contents",
      },
      {
        conditions: [{ button: 'rapidFill', value: true }],
        start: '["Rapid Fill" mode]',
        value:
          ': seleect a number at the bottom and then click/touch cell to toggle the number in that cell',
      },
      {
        conditions: [{ button: 'puzzleMode', value: true }],
        start: '[Blue Numbers]',
        value:
          ': are "Initial Input" numbers and cannot be changed unless in "Initial Input" mode',
      },
      {
        conditions: [{ button: 'puzzleMode', value: false }],
        start: '[Blue Numbers]',
        value:
          ': are numbers from the auto-generated puzzle and cannot be changed',
      },
      {
        conditions: [],
        start: '[Small Numbers]',
        value:
          ': in a cell represent pencil values; they are intended as notes of what could be in that cell as you work through the puzzle',
      },
      {
        conditions: [{ button: 'rapidFill', value: false }],
        start: '[Hold shift]',
        value:
          ': while entering a number will toggle the input number as a pencil value for the selected cell',
      },
    ],
  },
  {
    header: 'Options Buttons',
    instructions: [
      {
        conditions: [],
        start: '[Manual/Auto]',
        value:
          ': toggles between a manually input puzzle and an automatically generated puzzle',
      },
      {
        conditions: [{ button: 'puzzleMode', value: true }],
        start: '[Initial Input Mode]',
        value: ': if on allows blue numbers to be written or changed',
      },
      {
        conditions: [],
        start: '[Error Warning]',
        value:
          ": if on will highlight any conflicts in numbers in red; note-- won't necessarily call out a value that is incorrect compared to solution, will just highlight any current conflicts on the board",
      },
      {
        conditions: [],
        start: "[Highlight Selected #'s]",
        value:
          ': if on will bold/highlight other cells that contain the value of the currently selected cell',
      },
      {
        conditions: [],
        start: '[Crosshairs]',
        value:
          ": if on will highlight current selected cell's row, column, and square",
      },
      {
        conditions: [],
        start: '[Arrow Scroll Off]',
        value: ': if on will prevent arrow keystrokes from scrolling',
      },
      {
        conditions: [],
        start: '[Auto-Remove Pencil]',
        value:
          ": if on inputting a pen value will remove all pencil notes of same value in the entered cell's row, column, and square",
      },
      {
        conditions: [],
        start: '[Rapid Fill]',
        value:
          ': if on allows user to input numbers by selecting a number at the bottom of the puzzle and then touching a cell',
      },
      {
        conditions: [],
        start: '[Pen/Pencil]',
        value:
          ': toggles between entering a value (black) or making note of a potential value (pencil)',
      },
    ],
  },
  {
    header: 'Game Play Buttons',
    instructions: [
      {
        conditions: [],
        start: '[Start/Pause/Resume Timer]',
        value: ': starts, pauses, or resumes timer',
      },
      {
        conditions: [],
        start: '[Reset Timer]',
        value: ': resets timer to 0',
      },
      {
        conditions: [],
        start: '[Autofill Pencil]',
        value: ': automatically fills in all pencil values',
      },
      {
        conditions: [{ button: 'puzzleMode', value: false }],
        start: '[New Puzzle]',
        value: ': starts a new puzzle with the selected difficulty',
      },
      {
        conditions: [{ button: 'puzzleMode', value: false }],
        start: '[Ez/Med/Hard]',
        value:
          ": toggle between different difficulties; won't be implemented into starting a new puzzle",
      },
      {
        conditions: [],
        start: '[Reset Input]',
        value:
          ': if there are any non-blue values, will clear those non-blue values; if only blue values, will clear the remaining blue values',
      },
    ],
  },
];
